import { defineComponent as _defineComponent } from 'vue'
import axios from 'axios'
import { onMounted, ref } from 'vue'

/** WordPress の /know-how/ カテゴリ。常に本番ポータルを参照する */
type WpMedia = {
  source_url?: string
  media_details?: { sizes?: { medium?: { source_url?: string } } }
}

type WpPost = {
  id: number
  link: string
  date: string
  title: { rendered: string }
  _embedded?: { 'wp:featuredmedia'?: WpMedia[] }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TopKnowhowList',
  setup(__props) {

/**
 * トップページの「お役立ちコラム」。ポータル(WordPress)から3件取って並べる。
 *
 * Top.vue（1,700行超）の分解で切り出した。取得も整形もこの中で完結するので、
 * 親は <top-knowhow-list /> を置くだけでよい。
 *
 * ⚠️ 中身はビルド時に存在しない API 取得コンテンツなので、Top.vue 側では
 * <!-- static:skip --> で囲んで静的トップ(public/top-content.html)から外す。
 * 外さないと見出しだけのガワが全ユーザーに焼かれる。
 */
const PORTAL_BASE = 'https://portal.yagish.jp'
const KNOWHOW_CATEGORY_ID = 58
const ARCHIVE_URL = `${PORTAL_BASE}/know-how/`

const posts = ref<WpPost[]>([])

/** アイキャッチ。medium があればそれ、無ければ原寸 */
function thumbOf(post: WpPost): string {
  const media = post._embedded && post._embedded['wp:featuredmedia']
  if (media && media[0]) {
    const sizes = media[0].media_details && media[0].media_details.sizes
    if (sizes && sizes.medium) return sizes.medium.source_url || ''
    return media[0].source_url || ''
  }
  return ''
}

function formatDate(d: string): string {
  return d ? d.slice(0, 10).replace(/-/g, '.') : ''
}

onMounted(() => {
  axios
    .get<WpPost[]>(`${PORTAL_BASE}/wp-json/wp/v2/posts`, {
      params: { categories: KNOWHOW_CATEGORY_ID, per_page: 3, _embed: true },
      timeout: 60000
    })
    .then((response) => {
      posts.value = response.data
    })
    .catch((error) => {
      // 取得できなくてもトップは出す（v-if で丸ごと消える）
      console.error('お役立ちコラムの取得エラー', error)
    })
})

return { __sfc: true,PORTAL_BASE, KNOWHOW_CATEGORY_ID, ARCHIVE_URL, posts, thumbOf, formatDate }
}

})